/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { geoSegmentDtoSchema } from "./geoSegmentDtoSchema.ts";
import { primaryTargetDtoSchema } from "./primaryTargetDtoSchema.ts";
import { segmentPillDtoSchema } from "./segmentPillDtoSchema.ts";
import { z } from "zod/v4";

export const marketSegmentationDtoSchema = z.object({
  get primaryTarget() {
    return primaryTargetDtoSchema.optional();
  },
  get firmSizes() {
    return z.array(segmentPillDtoSchema).optional();
  },
  get geographies() {
    return z.array(geoSegmentDtoSchema).optional();
  },
});
